const getState = state => state.ConflictsStore

const getFetchRequest = state => getState(state).fetchConflictsRequest
const getRefetchRequest = state => getState(state).refetchConflictsRequest
const getRetireRequest = state => getState(state).retireStudentRequest
const getResolveRequest = state => getState(state).resolveConflictRequest

const getConflicts = state => getState(state).conflicts

const getCurrentStep = state => getState(state).step

export {
  getFetchRequest,
  getRefetchRequest,
  getRetireRequest,
  getResolveRequest,
  getConflicts,
  getCurrentStep
}
